<template>
  <div class="workflow-stats-page">
    <el-row class="condition">
      <el-form size="small" :inline="true">
        <el-form-item label="创建时间：">
          <el-date-picker v-model="dateRange" type="daterange" align="right" unlink-panels range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 340px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" @click="query">查询</el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <div class="summary-section">
      <el-row :gutter="16">
        <el-col :span="6">
          <el-card shadow="never" class="summary-card">
            <div class="summary-number">{{ summary.submittedCount || 0 }}</div>
            <div class="summary-label">提交问题</div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="never" class="summary-card pending">
            <div class="summary-number">{{ summary.pendingCount || 0 }}</div>
            <div class="summary-label">待处理</div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="never" class="summary-card processed">
            <div class="summary-number">{{ summary.processedCount || 0 }}</div>
            <div class="summary-label">已处理</div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="never" class="summary-card overdue">
            <div class="summary-number">{{ summary.overdueCount || 0 }}</div>
            <div class="summary-label">逾期处理</div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <el-tabs v-model="activeTab" class="stats-tabs">
      <el-tab-pane label="明细" name="detail">
        <el-card shadow="never" class="table-card">
          <div slot="header">按人员统计</div>
          <el-table v-loading="loading" :data="byPerson" stripe style="width: 100%" empty-text="暂无数据">
            <el-table-column type="index" label="序号" width="60" />
            <el-table-column prop="adminName" label="姓名" min-width="100" show-overflow-tooltip />
            <el-table-column prop="createdCount" label="创建问题" width="90" sortable />
            <el-table-column prop="handledCount" label="处理问题" width="90" sortable />
            <el-table-column prop="completedCount" label="办结问题" width="90" sortable />
            <el-table-column prop="overdueCount" label="逾期次数" width="90" sortable />
            <el-table-column label="平均逾期时长" min-width="120">
              <template slot-scope="scope">
                {{ formatDuration(scope.row.avgOverdueSeconds) }}
              </template>
            </el-table-column>
            <el-table-column label="处理平均耗时" min-width="120">
              <template slot-scope="scope">
                {{ formatDuration(scope.row.avgProcessingSeconds) }}
              </template>
            </el-table-column>
            <el-table-column label="创建占比" width="100">
              <template slot-scope="scope">
                {{ scope.row.createdRatio | percentFilter }}
              </template>
            </el-table-column>
            <el-table-column label="处理占比" width="100">
              <template slot-scope="scope">
                {{ scope.row.handledRatio | percentFilter }}
              </template>
            </el-table-column>
            <el-table-column label="办结占比" width="100">
              <template slot-scope="scope">
                {{ scope.row.completedRatio | percentFilter }}
              </template>
            </el-table-column>
            <el-table-column label="逾期占比" width="100">
              <template slot-scope="scope">
                {{ scope.row.overdueRatio | percentFilter }}
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <el-card shadow="never" class="table-card">
          <div slot="header">按问题类型统计</div>
          <el-table v-loading="loading" :data="byTag" stripe style="width: 100%" empty-text="暂无数据">
            <el-table-column type="index" label="序号" width="60" />
            <el-table-column prop="name" label="问题类型" min-width="120" show-overflow-tooltip />
            <el-table-column label="全流程平均耗时" min-width="130">
              <template slot-scope="scope">
                {{ formatDuration(scope.row.avgFullProcessSeconds) }}
              </template>
            </el-table-column>
            <el-table-column label="平均经手人" width="110">
              <template slot-scope="scope">
                <span v-if="scope.row.avgHandlerCount != null">{{ scope.row.avgHandlerCount | numFormat(2) }}</span>
                <span v-else>—</span>
              </template>
            </el-table-column>
            <el-table-column prop="overdueCount" label="逾期次数" width="90" sortable />
            <el-table-column label="逾期率" width="100">
              <template slot-scope="scope">
                {{ scope.row.overdueRate | percentFilter }}
              </template>
            </el-table-column>
            <el-table-column label="平均逾期时长" min-width="120">
              <template slot-scope="scope">
                {{ formatDuration(scope.row.avgOverdueSeconds) }}
              </template>
            </el-table-column>
            <el-table-column label="逾期占比" width="100">
              <template slot-scope="scope">
                {{ scope.row.overdueRatio | percentFilter }}
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <el-card shadow="never" class="table-card">
          <div slot="header">按关联方统计</div>
          <el-table v-loading="loading" :data="byRelatedParty" stripe style="width: 100%" empty-text="暂无数据">
            <el-table-column type="index" label="序号" width="60" />
            <el-table-column prop="name" label="关联方" min-width="120" show-overflow-tooltip />
            <el-table-column label="全流程平均耗时" min-width="130">
              <template slot-scope="scope">
                {{ formatDuration(scope.row.avgFullProcessSeconds) }}
              </template>
            </el-table-column>
            <el-table-column label="平均经手人" width="110">
              <template slot-scope="scope">
                <span v-if="scope.row.avgHandlerCount != null">{{ scope.row.avgHandlerCount | numFormat(2) }}</span>
                <span v-else>—</span>
              </template>
            </el-table-column>
            <el-table-column prop="overdueCount" label="逾期次数" width="90" sortable />
            <el-table-column label="逾期率" width="100">
              <template slot-scope="scope">
                {{ scope.row.overdueRate | percentFilter }}
              </template>
            </el-table-column>
            <el-table-column label="平均逾期时长" min-width="120">
              <template slot-scope="scope">
                {{ formatDuration(scope.row.avgOverdueSeconds) }}
              </template>
            </el-table-column>
            <el-table-column label="逾期占比" width="100">
              <template slot-scope="scope">
                {{ scope.row.overdueRatio | percentFilter }}
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-tab-pane>

      <el-tab-pane label="图表" name="chart" lazy>
        <div v-loading="loading" class="chart-section">
          <div class="chart-toolbar">
            <span class="chart-toolbar-label">日期粒度：</span>
            <el-radio-group v-model="granularity" size="small" @change="onGranularityChange">
              <el-radio-button v-for="item in timeGranularityOpts" :key="item.value" :label="item.value">
                按{{ item.label }}
              </el-radio-button>
            </el-radio-group>
          </div>

          <el-card shadow="never" class="chart-card">
            <div slot="header" class="chart-card-header">创建问题</div>
            <Chart v-if="hasChartData && activeTab === 'chart'" ref="createdChart" :option="createdChartOption"
              :height="300" :on-load="onCreatedChartLoad" />
            <div v-else-if="!hasChartData" class="chart-empty">暂无数据，请先查询</div>
          </el-card>

          <el-card shadow="never" class="chart-card">
            <div slot="header" class="chart-card-header">处理问题</div>
            <Chart v-if="hasChartData && activeTab === 'chart'" ref="handledChart" :option="handledChartOption"
              :height="300" :on-load="onHandledChartLoad" />
            <div v-else-if="!hasChartData" class="chart-empty">暂无数据，请先查询</div>
          </el-card>

          <el-card shadow="never" class="chart-card">
            <div slot="header" class="chart-card-header">办结问题</div>
            <Chart v-if="hasChartData && activeTab === 'chart'" ref="completedChart" :option="completedChartOption"
              :height="300" :on-load="onCompletedChartLoad" />
            <div v-else-if="!hasChartData" class="chart-empty">暂无数据，请先查询</div>
          </el-card>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getWorkflowStats } from "@/api/workflow";
import { DateUtil, UnitUtil } from "@/util";
import Chart from "@/components/Chart";
import { mapState } from "vuex";

const DEFAULT_TIME_GRANULARITY_OPTS = [
  { value: "DAY", label: "日" },
  { value: "WEEK", label: "周" },
  { value: "MONTH", label: "月" },
  { value: "YEAR", label: "年" }
];

const CHART_LINE_COLORS = ["#fac858", "#73c0de", "#ee6666", "#5470c6", "#91cc75", "#fc8452"];

function defaultDateRange() {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - 6);
  return [DateUtil.format(start, "yyyy-MM-dd"), DateUtil.format(end, "yyyy-MM-dd")];
}

function toDateTimeRange(dateRange) {
  if (!dateRange || dateRange.length !== 2) {
    return { startTime: null, endTime: null };
  }
  return {
    startTime: `${dateRange[0]} 00:00:00`,
    endTime: `${dateRange[1]} 23:59:59`
  };
}

/** 解析图表数据 */
function normalizeChartData(data) {
  const chart = data.chart || {};
  return {
    granularity: chart.granularity || "DAY",
    dateLabels: chart.dateLabels || [],
    personNames: chart.personNames || [],
    createdSeries: chart.createdSeries || [],
    handledSeries: chart.handledSeries || [],
    completedSeries: chart.completedSeries || []
  };
}

function formatChartDateLabel(label, granularity) {
  if (!label) {
    return label;
  }
  if ((granularity === "DAY" || granularity === "WEEK") && /^\d{4}-\d{2}-\d{2}$/.test(label)) {
    return label.slice(5);
  }
  return label;
}

function buildLineOption(chartData, seriesKey) {
  const dateLabels = chartData.dateLabels || [];
  const personNames = chartData.personNames || [];
  const seriesData = chartData[seriesKey] || [];
  const granularity = chartData.granularity || "DAY";
  const xLabels = dateLabels.map((d) => formatChartDateLabel(d, granularity));
  return {
    color: CHART_LINE_COLORS,
    tooltip: {
      trigger: "axis"
    },
    legend: {
      data: personNames,
      bottom: 0,
      type: personNames.length > 8 ? "scroll" : "plain"
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "14%",
      top: "8%",
      containLabel: true
    },
    xAxis: {
      type: "category",
      name: "日期",
      data: xLabels,
      boundaryGap: false,
      axisLabel: {
        interval: xLabels.length > 12 ? "auto" : 0,
        rotate: xLabels.length > 8 ? 35 : 0
      }
    },
    yAxis: {
      type: "value",
      minInterval: 1,
      name: "数量"
    },
    series: personNames.map((name, index) => ({
      name,
      type: "line",
      smooth: true,
      symbol: "circle",
      symbolSize: 6,
      data: (seriesData[index] || []).map((v) => v || 0)
    }))
  };
}

export default {
  name: "WorkFlowStats",
  components: { Chart },
  data() {
    return {
      loading: false,
      activeTab: "detail",
      dateRange: defaultDateRange(),
      granularity: "DAY",
      summary: {},
      byPerson: [],
      byTag: [],
      byRelatedParty: [],
      chartData: {
        granularity: "DAY",
        dateLabels: [],
        personNames: [],
        createdSeries: [],
        handledSeries: [],
        completedSeries: []
      }
    };
  },
  computed: {
    ...mapState({
      timeGranularityOpts(state) {
        const opts = state.enumMap["TIME_GRANULARITY"];
        return opts && opts.length ? opts : DEFAULT_TIME_GRANULARITY_OPTS;
      }
    }),
    hasChartData() {
      const labels = this.chartData.dateLabels || [];
      const persons = this.chartData.personNames || [];
      return labels.length > 0 && persons.length > 0;
    },
    createdChartOption() {
      return buildLineOption(this.chartData, "createdSeries");
    },
    handledChartOption() {
      return buildLineOption(this.chartData, "handledSeries");
    },
    completedChartOption() {
      return buildLineOption(this.chartData, "completedSeries");
    }
  },
  watch: {
    activeTab(val) {
      if (val === "chart") {
        this.$nextTick(() => {
          this.$nextTick(() => this.refreshCharts());
        });
      }
    }
  },
  mounted() {
    this.query();
  },
  methods: {
    query() {
      const { startTime, endTime } = toDateTimeRange(this.dateRange);
      if (!startTime || !endTime) {
        this.$message.warning("请选择创建时间范围");
        return;
      }
      this.loading = true;
      getWorkflowStats({
        startTime,
        endTime,
        granularity: this.granularity,
        _hideLoading: true
      })
        .then((res) => {
          const data = res.data || {};
          this.summary = data.summary || {};
          this.byPerson = data.byPerson || [];
          this.byTag = data.byTag || [];
          this.byRelatedParty = data.byRelatedParty || [];
          this.chartData = normalizeChartData(data);
          if (data.chart && data.chart.granularity) {
            this.granularity = data.chart.granularity;
          }
          this.$nextTick(() => this.refreshCharts());
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onGranularityChange() {
      this.query();
    },
    formatDuration(seconds) {
      if (seconds == null || seconds <= 0) {
        return "—";
      }
      return UnitUtil.timeFilter(seconds);
    },
    onCreatedChartLoad(chart) {
      this._createdChartInstance = chart;
      this.resizeChartInstance(chart);
    },
    onHandledChartLoad(chart) {
      this._handledChartInstance = chart;
      this.resizeChartInstance(chart);
    },
    onCompletedChartLoad(chart) {
      this._completedChartInstance = chart;
      this.resizeChartInstance(chart);
    },
    resizeChartInstance(chart) {
      if (chart && chart.resize) {
        this.$nextTick(() => chart.resize());
      }
    },
    refreshCharts() {
      if (this.activeTab !== "chart" || !this.hasChartData) {
        return;
      }
      const panels = [
        { ref: "createdChart", option: this.createdChartOption, instance: this._createdChartInstance },
        { ref: "handledChart", option: this.handledChartOption, instance: this._handledChartInstance },
        { ref: "completedChart", option: this.completedChartOption, instance: this._completedChartInstance }
      ];
      panels.forEach((panel) => {
        const chartComp = this.$refs[panel.ref];
        if (chartComp && chartComp.setOption) {
          chartComp.setOption(panel.option, true);
        }
        const instance = panel.instance || (chartComp && chartComp.chart);
        if (instance && instance.resize) {
          instance.resize();
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.workflow-stats-page {
  padding: 16px;

  .condition {
    margin-bottom: 16px;
  }

  .summary-section {
    margin-bottom: 16px;
  }

  .summary-card {
    text-align: center;

    .summary-number {
      font-size: 28px;
      font-weight: 600;
      line-height: 1.2;
      color: #303133;
    }

    .summary-label {
      margin-top: 8px;
      font-size: 14px;
      color: #909399;
    }

    &.pending .summary-number {
      color: #e6a23c;
    }

    &.processed .summary-number {
      color: #67c23a;
    }

    &.overdue .summary-number {
      color: #f56c6c;
    }
  }

  .stats-tabs {
    margin-top: 8px;
  }

  .table-card {
    margin-bottom: 16px;
  }

  .chart-section {
    .chart-toolbar {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .chart-toolbar-label {
        margin-right: 8px;
        font-size: 14px;
        color: #606266;
      }
    }

    .chart-card {
      margin-bottom: 16px;
    }

    .chart-card-header {
      font-weight: 500;
    }

    .chart-empty {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 240px;
      color: #909399;
      font-size: 14px;
    }
  }
}
</style>
